import { useLocalisation } from '@3plearning/lingui-cdn';

export const useTranslations = () => {
    const { i18n } = useLocalisation();

    return {
        signIns: i18n.t`Usage - SignIns`,
        timeOnline: i18n.t`Usage - TimeOnline`,
        curriculumPoints: i18n.t`Usage - CurriculumPoints`,
        liveMathsPoints: i18n.t`Usage - LiveMathsPoints`,
        goldBars: i18n.t`Usage - GoldBars`
    };
};



// WEBPACK FOOTER //
// ./components/usage/hooks/use-translations.js